import routes from "../seo/routeMetadata.json";

const PUBLIC_HOSTS = new Set([
  "student-loan-calculator.co.uk",
  "www.student-loan-calculator.co.uk",
  "studentcalc.co.uk",
  "www.studentcalc.co.uk",
]);
const REGISTERED_PATHS = new Set(routes.map((route) => route.path));

/** Host matching is exact and case-insensitive because browser hostnames are normalized. */
export const isPublicHost = (hostname) =>
  PUBLIC_HOSTS.has(String(hostname || "").trim().toLowerCase());

/** Only registered paths are reportable; queries and user-provided paths are dropped. */
export const reportablePath = (path) => {
  const clean = String(path || "/").split(/[?#]/)[0].replace(/\/$/, "") || "/";
  return REGISTERED_PATHS.has(clean) ? clean : "/404";
};

const isIpAddress = (hostname) => {
  if (hostname.includes(":")) return true;
  const parts = hostname.split(".");
  return parts.length === 4 && parts.every((part) => /^\d+$/.test(part) && Number(part) <= 255);
};

const isPrivateOrLocalHost = (hostname) =>
  !hostname ||
  isIpAddress(hostname) ||
  hostname === "localhost" ||
  hostname.endsWith(".localhost") ||
  hostname.endsWith(".local") ||
  hostname.endsWith(".internal") ||
  hostname.endsWith(".test") ||
  hostname.endsWith(".invalid") ||
  hostname.endsWith(".example") ||
  hostname.endsWith(".home.arpa") ||
  hostname.endsWith(".lan");

/** Return a parseable public HTTP(S) referrer origin with only scheme and host. */
export const referrerHost = (referrer) => {
  if (!referrer) return "";
  try {
    const url = new URL(referrer);
    const hostname = url.hostname.toLowerCase().replace(/\.+$/, "");
    if (
      !(url.protocol === "http:" || url.protocol === "https:") ||
      url.username ||
      url.password ||
      !hostname.includes(".") ||
      isPrivateOrLocalHost(hostname)
    ) return "";
    return `${url.protocol}//${hostname}/`;
  } catch {
    return "";
  }
};

export const publicLocation = (hostname, path) => {
  const safeHostname = String(hostname || "").trim().toLowerCase();
  return isPublicHost(safeHostname) ? `https://${safeHostname}${reportablePath(path)}` : "";
};
